import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { AddUser } from '../models/manageUsers/add-user.model';
import { catchError, map, tap } from 'rxjs/operators';
import { appConfig } from './auth-gaurd.service';
import { Observable, of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { FavPage } from '../models/personnel/fav-page.model';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ManageUserService {
  host: string = environment.apiUrl + 'personal';
  userModel = new AddUser();
  salesChnlsUserData: AddUser[] = [];
  userTypes: string[] = [];
  comPlansUserData: AddUser[] = [];
  allComPlansUserData: AddUser[] = [];
  corps: number[] = [];
  salesRepTypes: string[] = [];
  selectedUserModel = new AddUser();
  selectedUserDocModel: AddUser[] = [];
  loginUserData = new AddUser();
  supervisorNamesSet = new Set<string>();
  payrollCalender: string[] = [];
  private completeHistoryCache = new Map<string, AddUser[]>();
  private getUsersCache = new Map<string, AddUser[]>();
  userSearchCacheKey: string = '';
  userSearchCacheData: AddUser[] = [];
  
  constructor(private router: Router, private http: HttpClient,
    private logger: LoggerService) { }
    optsCat = [];

  private cloneUsers(users: AddUser[]): AddUser[] {
    return JSON.parse(JSON.stringify(users || []));
  }

  public getPayrollCalendar(): Observable<AddUser[]> {
    return this.http.get<AddUser[]>(`${this.host}/getpayrollcalendarlist`);
  }

  public getUserAsOfDate(employeeId: string): Observable<AddUser> {
    return this.http.get<AddUser>(`${this.host}/getuserasofdate` + '/' + employeeId);
  }

  public getUserPopupData(employeeId: string): Observable<AddUser> {
    return this.http.get<AddUser>(`${this.host}/getuserasofdate/popup` + '/' + employeeId);
  }
  
  public getUserByAsOfDt(employeeId: string, effective_date: string, id: string): Observable<AddUser> {
    return this.http.get<AddUser>(`${this.host}/getuserbyasofdate` + '/' + employeeId + '/' + effective_date+ '/' + id);
  }

  public getCompleteEmployeeHistory(employeeId: string, forceRefresh: boolean = false): Observable<AddUser[]> {
    // This method gets all records (active + inactive + pending) for an employee
    // We'll combine active and inactive records to get complete history
    if (!employeeId) {
      return of([]);
    }

    if (!forceRefresh && this.completeHistoryCache.has(employeeId)) {
      return of(this.cloneUsers(this.completeHistoryCache.get(employeeId)));
    }

    return this.http.get<AddUser[]>(`${this.host}/getcompleteemployeehistory` + '/' + employeeId).pipe(
      map((data: AddUser[]) => {
        const history = data || [];
        this.completeHistoryCache.set(employeeId, this.cloneUsers(history));
        return this.cloneUsers(history);
      })
    );
  }

  public clearCompleteEmployeeHistoryCache(employeeId?: string): void {
    if (employeeId) {
      this.completeHistoryCache.delete(employeeId);
      return;
    }
    this.completeHistoryCache.clear();
  }

  public clearUserSearchCache(): void {
    this.userSearchCacheKey = '';
    this.userSearchCacheData = [];
    this.getUsersCache.clear();
  }

  public updateEmployeeStatus(addUserModel: AddUser) {
    let url = this.host + '/updateemployeestatus';
    let body = addUserModel ? JSON.stringify(addUserModel) : '';
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public getProfiles(profilestatus: string, first_name: string, last_name: string, employeeId: string, id: any, supervisor_id: number, user_type: string, sales_rep_channel: string, comm_plan_id: number, payroll_start_date: string, userRole: string) {
    const url = this.host + '/getusers/' + profilestatus + '/' + first_name + '/' + last_name + '/' + employeeId + '/' + id + '/' + supervisor_id + '/' + user_type + '/' + sales_rep_channel + '/' + comm_plan_id + '/' + payroll_start_date + '/' + userRole;
    console.log(url);
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getUsers(profilestatus: string, first_name: string, last_name: string, employeeId: string,sales_rep_id:string,soft_termination_date:Date ,id: any, supervisor_id: number, user_type: string, sales_rep_channel: string, comm_plan_id: number, payroll_start_date: string, userRole: string) {
    const cacheKey = JSON.stringify({
      profilestatus,
      first_name,
      last_name,
      employeeId,
      sales_rep_id,
      soft_termination_date,
      id,
      supervisor_id,
      user_type,
      sales_rep_channel,
      comm_plan_id,
      payroll_start_date,
      userRole
    });

    if (this.getUsersCache.has(cacheKey)) {
      return of(this.cloneUsers(this.getUsersCache.get(cacheKey)));
    }

    const url = this.host + '/getusers/' + profilestatus + '/' + first_name + '/' + last_name + '/' + employeeId + '/' + sales_rep_id + '/' + soft_termination_date + '/' + id + '/' + supervisor_id + '/' + user_type + '/' + sales_rep_channel + '/' + comm_plan_id + '/' + payroll_start_date + '/' + userRole;
    console.log('getUser API URL:', url);
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => {
          const users = data || [];
          this.getUsersCache.set(cacheKey, this.cloneUsers(users));
          return this.cloneUsers(users);
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getUsersPending(profilestatus: string, first_name: string, last_name: string, employeeId: string, id: any, userRole: string) {
    const url = this.host + '/getuserspending/' + profilestatus + '/' + first_name + '/' + last_name + '/' + employeeId + '/' + id + '/' + userRole;
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public getProfiles1(profilestatus: string, payroll_end_date: Date) {
    const url = this.host + '/getprofiles/' + profilestatus + '/' + payroll_end_date;
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

 public searchUsers(profilestatus: string, payroll_end_date: Date) {
    const url = this.host + '/getuserinfo/' + profilestatus + '/' + payroll_end_date;
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public searchUsersByDate(effective_date: Date) {
    const url = this.host + '/getuserinfobydate/' + effective_date;
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public validateCredentials(loggedInEmployeeId: string, loggedInNetworkId: string, loggedInEmail: string): Observable<AddUser[]> {
    return this.http.get<AddUser[]>(`${this.host}/validatecredentials/` + loggedInEmployeeId + '/' + loggedInNetworkId + '/' + loggedInEmail);
  }

  public filterByEmpId(empid: string) {
    //console.log("empid = " + empid);
    if (empid !== "") {
      const url = this.host + '/filterbyempid/' + empid;
      return this.http.get<AddUser[]>(url)
        .pipe(
          map((data: AddUser[]) => {
            return data;
          }), catchError(error => {
            this.logger.info(' error ==> ', error);
            return throwError(error);
          })
        )
    }
  }

  public getPrePopulatedUserData() {
    const url = this.host + '/getuserfields';
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public bulkUpdate(addUserModel: AddUser[]): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/bulkupdate`, addUserModel);
  }

  // public bulkUpdate(addUserModel: AddUser[]) {
  //   let url = this.host + '/bulkupdate';
  //   let body = addUserModel ? JSON.stringify(addUserModel) : '';
  //   return this.http.post(url, body, appConfig.httpOptions)
  //     .pipe(
  //       catchError(this.handleError)
  //     )
  // }

  public filterByEmpIdHome(empid: string,effective_date:Date) {
    //console.log("empid = " + empid);
    if (empid !== "") {
      const url = this.host + '/filterbyempidhome/' + empid + '/' + effective_date;
      return this.http.get<AddUser[]>(url)
        .pipe(
          map((data: AddUser[]) => {
            return data;
          }), catchError(error => {
            this.logger.info(' error ==> ', error);
            return throwError(error);
          })
        )
    }
  }

  public getMultiProfileCount(empid: string) {
    if (empid !== "") {
      const url = this.host + '/getmultiprofilecount/' + empid;
      return this.http.get<any>(url)
        .pipe(
          map((data: any) => {
            return data;
          }), catchError(error => {
            this.logger.info(' error ==> ', error);
            return throwError(error);
          })
        )
    }
  }

  public filterByEmpIdByRole(empid: string, role: string) {
    //console.log("empid = " + empid);
    if (empid !== "") {
      const url = this.host + '/filterbyempidbyrole/' + empid + '/' + role;
      return this.http.get<AddUser[]>(url)
        .pipe(
          map((data: AddUser[]) => {
            return data;
          }), catchError(error => {
            this.logger.info(' error ==> ', error);
            return throwError(error);
          })
        )
    }
  }

  public getPendingUsers() {
    const url = this.host + '/pendingprofiles';
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

public getRecentPendingUsers() {
  const url = this.host + '/recentpendingprofiles';
  return this.http.get<AddUser[]>(url)
    .pipe(
      map((data: AddUser[]) => {
        return data;
      }), catchError(error => {
        this.logger.info(' error ==> ', error);
        return throwError('Something went wrong!');
      })
    )
}

  public getPendingUsersPage(limit: number, offset: number) {
    const url = `${this.host}/pendingprofilespage?limit=${limit}&offset=${offset}`;
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => data),
        catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      );
  }

  public getPendingUsersCount() {
    const url = `${this.host}/pendingprofilescount`;
    return this.http.get<number>(url)
      .pipe(
        map((count: number) => count),
        catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      );
  }

  public getAllPendingUsersLight() {
    const url = `${this.host}/pendingprofilesall`;
    return this.http.get<AddUser[]>(url)
      .pipe(
        map((data: AddUser[]) => data),
        catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      );
  }

  public deleteUser(addUserModel: AddUser[]) {
    let url = this.host + '/deleteUser';
    return this.http.post(url, addUserModel || [], appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public saveUser1(addUserModel: AddUser[]) {
    let url = this.host + '/bulkupdateuserprofiles';
    let body = addUserModel ? JSON.stringify(addUserModel) : '';
    return this.http.post(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public saveUser(addUserModel: AddUser[]): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/bulkupdateuserprofiles`, addUserModel);
  }

  public saveUserAdmin(addUserModel: AddUser[]): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/saveadmin`, addUserModel);
  }

  public updateUser(addUserModel: AddUser) {
    let url = this.host + '/updateuserprofile';
    let body = addUserModel ? JSON.stringify(addUserModel) : '';
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public updateProfile(addUserModel: AddUser) {
    let url = this.host + '/updateprofile';
    let body = addUserModel ? JSON.stringify(addUserModel) : '';
    return this.http.put(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public addMenuToFav(favPage: FavPage) {
    this.logger.info('==Add page to favourites====');
    let url = this.host + '/addpagetofav';
    this.logger.info('UserInfo ===> ', favPage);
    let body = favPage ? JSON.stringify(favPage) : '';
    this.logger.info('Request Body ==> ', body);
    return this.http.post(url, body, appConfig.httpOptions)
      .pipe(
        catchError(this.handleError)
      )
  }

  public deleteFavpage(id: number, empId: string): Observable<CustomHttpRespone> {
    let url = this.host + '/deletefavpage/';
    return this.http.delete<CustomHttpRespone>(url + id + '/' + empId);
  }

 public validateSalesRepId(salesRepId: string, currentScEmpId: string, effectiveDate?: string | Date | null): Observable<boolean> {
    // Use empty string for new users, or the actual sc_emp_id for existing users
    const scEmpIdParam = currentScEmpId || 'NEWUSER';
    let url = `${this.host}/validatesalesrepid/${salesRepId}/${scEmpIdParam}`;
    const effectiveDateParam = this.formatEffectiveDateParam(effectiveDate);
    if (effectiveDateParam) {
      url += `?effectiveDate=${encodeURIComponent(effectiveDateParam)}`;
    }
    return this.http.get<boolean>(url)
      .pipe(
        map((isActive: boolean) => {
          return isActive;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Error validating Sales Rep ID');
        })
      )
  }

  private formatEffectiveDateParam(value?: string | Date | null): string | null {
    if (value == null || value === '') {
      return null;
    }
    if (typeof value === 'string') {
      return value.substring(0, 10);
    }
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      return null;
    }
    return parsed.toISOString().split('T')[0];
  }

  public handleError(error: any) {
    let errorMessage = '';
    if (typeof error === 'string') {
      errorMessage = error;
    } else if (error?.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      const status = error?.status ?? 'Unknown';
      const message = error?.error?.message || error?.message || 'Unexpected error';
      errorMessage = `Error Code: ${status}\nMessage: ${message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
